<template>
  <div id="browser-no-content" role="region">
    <h3 class="i-panel-empty-msg">
      <slot>{{ LANG.noContent }}</slot>
    </h3>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['LANG']),
  },
};
</script>

<style scoped lang='scss'>
.i-panel-empty-msg {
    text-align: center;
    top: 60%;
    position: relative;
    background-color: #fff;
    color: #6b6b6b;
    font-family: "Roboto Regular", sans-serif;
    font-size: 20px;
    padding: 10px;
}

#browser-no-content {
    width: 100%;
    height: 100%;
    background-image: url('/imperia/images/undraw/edit_item.svg');
    background-color: #fff;
    background-size: 290px auto;
    background-position: top 40% left 50%;
    background-repeat: no-repeat;
}
</style>
